import React from 'react'

import { cn } from '../ui/cn'

import { AltBlock } from './AltBlock'

interface IntroBlockProps {
  title?: string | React.ReactNode
  cta?: React.ReactNode
  children?: string | React.ReactNode
}

export const IntroBlock = ({ title, cta, children }: IntroBlockProps): React.ReactElement => {
  return (
    <AltBlock
      innerClassName={cn(
        'snplay:grid snplay:grid-cols-1 snplay:gap-8',
        'snplay:sm:grid-cols-2 snplay:max-w-7xl',
      )}
    >
      <div className="snplay:self-center">
        <h1 className={cn('snplay:text-4xl snplay:font-bold', cta && 'snplay:mb-8')}>{title}</h1>
        {cta}
      </div>
      <div className="snplay:space-y-4 snplay:text-base snplay:text-ui-secondary">{children}</div>
    </AltBlock>
  )
}
